module.exports = __webpack_public_path__ + "img/copywriting.037d9bc3.png";